import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GrowthReportSharedState } from '../models/common.store.model';
import { GrowthReportStoreNames } from '../models/constants';

const selectGrowthReportSharedState = createFeatureSelector<GrowthReportSharedState>(
  GrowthReportStoreNames.SHARED,
);

export const selectIsLoading = createSelector(
  selectGrowthReportSharedState,
  (state: GrowthReportSharedState) => state.isLoading,
);

export const selectIsMultiStageReportLoading = createSelector(
  selectGrowthReportSharedState,
  (state: GrowthReportSharedState) => state.isMultiStageReportLoading,
);

export const selectLocale = createSelector(
  selectGrowthReportSharedState,
  (state: GrowthReportSharedState) => state.locale,
);

export const selectCommandQuery = createSelector(
  selectGrowthReportSharedState,
  (state: GrowthReportSharedState) => state.commandQuery,
);

export const selectShowSideNav = createSelector(
  selectGrowthReportSharedState,
  (state: GrowthReportSharedState) => state.showSideNav,
);

export const selectInputParams = createSelector(selectGrowthReportSharedState, (state) => state?.inputParams);
